<template>
  <div class="home-container">
    <!-- Carrousel de vidéos -->
    <div class="carousel">
      <div class="carousel-videos" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
        <div v-for="(video, index) in videos" :key="index" class="carousel-video">
          <video :src="video" controls autoplay muted loop playsinline webkit-playsinline
                 @dblclick="disableFullscreen" id="VideoWorker-0" class="video-player"></video>
          <!-- Texte affiché devant les vidéos -->
   <div class="carousel-text">
            <h1 class="welcome-title">BIENVENUE CHEZ SOCIETE SUPRACARE</h1>
            <p class="welcome-description">
              Supracare est votre partenaire de confiance pour des équipements de laboratoire,
              consommables, produits chimiques, réactifs et compléments alimentaires de haute qualité.
            </p>
            <!-- Boutons sous le texte -->
            <div class="button-group">
              <button @click="goToProduits" class="custom-button">Produits de laboratoire</button>
              <p class="button-description">Découvrez nos derniers produits de laboratoire.</p>
              <button @click="goToProduitsV" class="custom-button">Compléments alimentaires</button>
              <p class="button-description">Découvrez notre gamme de compléments alimentaires.</p>
            </div>
            <div class="brochure-section">
            <h2>Téléchargez notre brochure</h2>
           <a href="/Brochure materiel.pdf" download class="brochure-button">
          <i class="fas fa-file-pdf"></i> Brochure Equipements Labo</a>
          </div>
          </div>

        </div>
      </div>

      <div class="carousel-dots">
        <span
          v-for="(video, index) in videos"
          :key="index"
          :class="{ 'active': currentIndex === index }"
          class="carousel-dot"
          @click="goToSlide(index)"
        ></span>
      </div>
    </div>

    <!-- Paragraphe avec image -->
       <div class="welcome">
        <h2>SUPRACARE - DISTRIBUTEUR DES PRODUITS DE LABORATOIRE</h2>
      </div>
    <div class="welcome-section">
      <div class="welcome-content">
        <div class="welcome-image-container">
          <h2 class="welcome-heading">Bienvenue chez notre entreprise</h2>
          
          <img src="@/assets/Im1.png" alt="Image" class="welcome-image">
        </div>
        <br />
      
        <p class="welcome-text">
          Supracare est une entreprise spécialisée dans la fourniture de solutions complètes pour les professionnels des secteurs médicaux, paramédicaux et scientifiques. Nous proposons une large gamme de produits, allant des réactifs et équipements de laboratoire aux dispositifs médicaux et compléments alimentaires, répondant aux besoins diversifiés de nos clients.

Avec un réseau international de partenaires, Supracare garantit une disponibilité constante de produits de haute qualité, conformes aux normes internationales les plus strictes. Nous nous engageons également à offrir un service après-vente fiable et un accompagnement personnalisé pour répondre aux exigences spécifiques de chaque client.

Chez Supracare, nous comprenons l’importance de la fiabilité et de la précision dans nos domaines d’intervention. C’est pourquoi nous nous efforçons de fournir des solutions innovantes et des services adaptés, contribuant ainsi à l’excellence de vos opérations au quotidien.
         
          </p>

      </div>
    </div>

       
    <div class="features-section">
  <div class="feature">
    <i class="icon fas fa-handshake"></i>
    <h3>Collaboration</h3>
    <hr>
    <p>Nous travaillons main dans la main avec nos partenaires pour atteindre des résultats exceptionnels.</p>
  </div>
  <div class="feature">
    <i class="icon fas fa-users"></i>
    <h3>Accompagnement</h3>
    <hr>
    <p>Nous vous guidons à chaque étape pour garantir votre réussite et votre satisfaction.</p>
  </div>
  <div class="feature">
    <i class="icon fas fa-award"></i>
    <h3>Qualité</h3>
    <hr>
    <p>Notre priorité est de vous offrir des produits et services répondant aux plus hautes exigences.</p>
  </div>
</div>

    
                <!-- Slider d'images en mouvement -->

    <div class="container">
      <div class="vc_row wpb_row vc_row-fluid vc_custom_1533898819163 mpc-row">
        <!-- Espace avant le titre -->
        <div class="wpb_column vc_column_container vc_col-sm-2 mpc-column"></div>

        <!-- Contenu central : Titre et description -->
        <div class="wpb_column vc_column_container vc_col-sm-8 mpc-column">
          <div class="vc_column-inner">
            <div class="wpb_wrapper">
              <h2
                class="brands-title"
              >
                NOS PRODUITS
              </h2>
              <div class="wpb_text_column wpb_content_element vc_custom_1533894596725">
                <div class="wpb_wrapper">
                  <p style="text-align: center;">
                    SUPRACARE, spécialisé dans la distribution d’une large gamme de produits de laboratoire.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>    
      </div> 
    </div>   
   <div class="product-wrapper">
    <div class="product-container">
        <div class="product"><img decoding="async" src="@/assets/glove-latex.jpg" alt="Product 1"><h4>Glove Latex</h4></div>
        <div class="product"><img decoding="async" src="@/assets/Vacutest.jpg" alt="Product 4"><h4>Tubes sous vide</h4><p></p></div>
         <div class="product"><img decoding="async" src="@/assets/LINE-Automation-2.png" alt="Product 8"><h4>LINE Automation</h4></div>
        <div class="product"><img decoding="async" src="@/assets/AKLIDES.png" alt="Product 9"><h4>Analyzer</h4></div>
        <div class="product"><img decoding="async" src="@/assets/Micropipette.jpg" alt="Product 3"><h4>Micropipette</h4></div>
         <div class="product"><img decoding="async" src="@/assets/FLACON-BOUCHON-ROUGE.jpg" alt="Product 2"><h4>Flacon</h4><p></p></div>
        <div class="product"><img decoding="async" src="@/assets/BOITE-DE-PETRI.jpg" alt="Product 5"><h4>Boite De Petri</h4></div>
        <div class="product"><img decoding="async" src="@/assets/goodlife.png" alt="Product 11"><h4>Goodlife</h4></div>
        <div class="product"><img decoding="async" src="@/assets/REACTIF-.jpg" alt="Product 7"><h4>Réactifs</h4></div>
        <div class="product"><img decoding="async" src="@/assets/Multi-analyzer.png" alt="Product 10"><h4>Multi analyzer</h4></div>
        <div class="product"><img decoding="async" src="@/assets/bandage.jpg" alt="Product 10"><h4>Bandage</h4></div>
        <div class="product"><img decoding="async" src="@/assets/Alcohol-96.jpg" alt="Product 10"><h4>Alcohol</h4></div>
    </div>
  
</div>


      <!-- Conteneur de marques avec défilement -->
<div>
  <h2 class="brands-title">NOS PARTENAIRES</h2>
    <p style="text-align: center;">
       SUPRACARE travaille en partenariat avec des marques reconnues mondialement.
    </p>
  <div class="brands-wrapper">
  
    <!-- Bouton Précédent -->
    <span class="nav-button prev-button" @click="prevBrand">‹</span>

    <!-- Conteneur des marques avec défilement -->
    <div class="brand-container" :style="{ transform: `translateX(-${currentBrandIndex * 100}%)` }">
      <div v-for="(brand, index) in brands" :key="index" class="brand">
        <img :src="brand.logo" :alt="`Logo de ${brand.name}`" class="brand-logo" />
      </div>
    </div>

    <!-- Bouton Suivant -->
    <span class="nav-button next-button" @click="nextBrand">›</span>
  </div>
</div>
   <!-- Icône de défilement -->
    <div id="scrollIcon" v-show="showScrollIcon" :style="{ opacity: iconOpacity }">
      <a  href="http://www.supracare.ma/qualite-certifications" target="_blank">
        <img decoding="async" src="@/assets/certificats.png" alt="Icon">
      </a>
    </div>
  </div>

  
</template>

<script>
export default {
  name: 'HomeI',
  data() {
    return {
      videos: [
        require('@/assets/vid.mp4'),
      ],
        brands: [
        { name: "Marque 1", logo: require('@/assets/MARQUES/accumax.png') },
        { name: "Marque 2", logo: require('@/assets/MARQUES/flmedical.png') },
        { name: "Marque 3", logo: require('@/assets/MARQUES/fortress.png') },
        { name: "Marque 4", logo: require('@/assets/MARQUES/headway.png') },
        { name: "Marque 5", logo: require('@/assets/MARQUES/odak2.png')},
        { name: "Marque 6", logo: require('@/assets/MARQUES/polycheck.png') },
        { name: "Marque 7", logo: require('@/assets/MARQUES/singuway.png') },
       
      ],
      currentBrandIndex: 0,  // Index actuel pour les marques
      marqueInterval: null,   // Intervalle pour le défilement automatique
      currentIndex: 0,
      interval: null,
      showScrollIcon: true,  // Contrôle de l'affichage de l'icône
      iconOpacity: 1         // Opacité de l'icône
    };
  },
  mounted() {
    const video = document.getElementById('VideoWorker-0');
    if (video) {
      video.muted = true; // Force la vidéo à être muette
      video.loop = true;  // Force la boucle
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.controls = false; // Désactiver les contrôles de la vidéo
      
      // Lecture automatique avec gestion d'erreur
      video.play().catch(error => {
        console.log('La lecture automatique a été interrompue :', error);
      });

      // Ajouter un écouteur pour désactiver le plein écran lors du double-clic
      video.addEventListener('dblclick', this.disableFullscreen);
    }
      this.startAutoBrandScroll();  // Démarrer le défilement automatique des marques
  },
  
  beforeUnmount() {
    clearInterval(this.interval);
    const video = document.getElementById('VideoWorker-0');
    
    // Vérification si la vidéo existe avant de retirer l'écouteur d'événements
    if (video) {
      video.removeEventListener('dblclick', this.disableFullscreen);
    }
     clearInterval(this.marqueInterval);  // Nettoyer l'intervalle lors du démontage
  },
  
  methods: {
    goToCertification() {
      // Rediriger vers la page Qualité & Certifications
      this.$router.push('/qualite-certifications');
    },
    goToSlide(index) {
      this.currentIndex = index;
    },
    goToProduits() {
      this.$router.push('/produits');
    },
    goToProduitsV() {
      this.$router.push('/vitamines-mineraux');
    },
    toggleShowMore() {
      this.$router.push('/certification');
    },
    disableFullscreen(event) {
      event.preventDefault();
      event.stopPropagation();
    },
    nextBrand() {
      this.currentBrandIndex = (this.currentBrandIndex + 1) % this.brands.length;
    },
    prevBrand() {
      this.currentBrandIndex = (this.currentBrandIndex - 1) % this.brands.length;
    }, 
    startAutoBrandScroll() {
      this.marqueInterval = setInterval(() => {
        this.nextBrand();  // Avancer à la prochaine marque
}, 3000); // Changer toutes les 3 secondes
    },
  
  },
};

</script>


<style scoped>
/* ===== Base (clair par défaut) ===== */
.home-container{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:0}

/* ===== HERO / CARROUSEL VIDÉO ===== */
.carousel{position:relative;overflow:hidden;width:100%;height:800px;background:#fff}
.carousel-videos{display:flex;width:100%;height:100%;transition:transform .6s cubic-bezier(.22,.61,.36,1);will-change:transform}
.carousel-video{position:relative;min-width:100%;box-sizing:border-box;display:flex;align-items:center;justify-content:center;z-index:1}
.video-player{width:100%;height:100%;object-fit:cover;border-radius:0;pointer-events:none}

.carousel-text{
  position:absolute;top:30%;left:50%;transform:translateX(-50%);
  color:#333;background:rgba(247,247,250,.86);
  padding:0 30px;font-size:24px;text-align:center;z-index:2;width:70%;box-sizing:border-box;
  font-family:'Helvetica',sans-serif;border-radius:15px;animation:fadeIn 1.5s ease-in-out
}
.welcome-title{font-size:36px;color:#05305b;animation:fadeIn 3s ease-in-out infinite;font-family:'Gill Sans','Gill Sans MT',Calibri,'Trebuchet MS',sans-serif}
.welcome-description{font-size:18px;margin-top:10px;color:#555}

.button-group{display:flex;flex-direction:column;align-items:center;gap:15px;margin-top:20px}
.custom-button{
  background:transparent;color:#000;border:2px solid #05305b;padding:10px 20px;font-size:18px;border-radius:8px;cursor:pointer;
  transition:background .25s ease,transform .15s ease,box-shadow .25s ease
}
.custom-button:hover{background:#05305b;color:#fff;transform:translateY(-1px);box-shadow:0 10px 24px rgba(0,0,0,.12)}
.button-description{color:#090c78;font-size:14px;margin-top:-10px}

/* Dots & flèches (si tu ajoutes les flèches plus tard) */
.carousel-dots{position:absolute;bottom:20px;left:50%;transform:translateX(-50%);display:flex;gap:6px}
.carousel-dot{width:12px;height:12px;border-radius:999px;background:#fff;border:1px solid rgba(0,0,0,.2);cursor:pointer;transition:transform .15s ease}
.carousel-dot.active{background:#000;transform:scale(1.1)}

/* ===== BLOC BIENVENUE ===== */
.welcome{text-align:center;color:#05305b;font-size:25px;font-weight:800;margin:10px 0 8px;font-family:'Poppins',sans-serif;text-transform:uppercase;letter-spacing:2px}
.welcome-section{text-align:center;margin-top:20px}
.welcome-content{display:flex;align-items:center;justify-content:center;gap:20px;position:relative}
.welcome-image-container{position:relative;max-width:500px}
.welcome-heading{
  position:absolute;top:-30px;left:0;width:100%;text-align:center;font-size:20px;color:#090c78;
  font-family:'Gill Sans','Gill Sans MT',Calibri,'Trebuchet MS',sans-serif;background:rgba(255,255,255,.8);
  padding:15px;border-radius:8px;animation:fadeIn 3s ease-in-out infinite
}
.welcome-image{width:100%;border-radius:15px}
.welcome-text{font-size:20px;color:#333;line-height:1.6;text-align:left;max-width:700px;font-weight:300;font-family:'Segoe UI',Tahoma,Geneva,Verdana,sans-serif;margin-bottom:20px}

/* ===== Avantages ===== */
.features-section{display:flex;justify-content:space-between;gap:.1px;margin:40px 2px}
.feature{
  text-align:center;flex:1;background:#02284e;padding:20px;border-radius:12px;
  box-shadow:0 8px 22px rgba(0,0,0,.08);transition:transform .2s ease,box-shadow .25s ease
}
.feature:hover{transform:translateY(-8px);box-shadow:0 14px 30px rgba(0,0,0,.14)}
.icon{font-size:40px;color:#e8ebef;margin-bottom:10px}
h3{color:#fff;font-size:1.5rem}
hr{width:50px;border:1px solid #e0240b;margin:10px auto}
p{color:#6c7a86;font-size:1rem}

/* ===== TITRE SECTION PRODUITS (contenu WPB laissé intact) ===== */
.container .vc_custom_heading{letter-spacing:.01em}

/* ===== SLIDER PRODUITS (marquee fluide) ===== */
.product-title{color:#05305b;font-weight:800;letter-spacing:.01em;font-size:clamp(20px,2.2vw,32px);text-align:center;margin:28px 0 18px}
.product-wrapper{
  position:relative;width:100%;overflow:hidden;padding:0 2vw;margin:0 auto 48px;--fadeW:60px
}
.product-wrapper::before,.product-wrapper::after{
  content:"";position:absolute;top:0;bottom:0;width:var(--fadeW);z-index:2;pointer-events:none;
  background:linear-gradient(to right,rgba(255,255,255,1),rgba(255,255,255,0))
}
.product-wrapper::before{left:0}
.product-wrapper::after{right:0;transform:scaleX(-1)}
.product-container{display:flex;align-items:stretch;gap:16px;will-change:transform;animation:products-marquee 24s linear infinite}
.product-wrapper:hover .product-container{animation-play-state:paused}
@keyframes products-marquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}

.product{
  flex:0 0 auto;width:clamp(180px,18vw,240px);background:#fff;border:1px solid rgba(0,0,0,.06);
  border-radius:16px;padding:12px;text-align:center;box-shadow:0 10px 24px rgba(0,0,0,.08);
  transition:transform .2s ease,box-shadow .25s ease,filter .2s ease;outline:none
}
.product:hover{transform:translateY(-4px);box-shadow:0 18px 36px rgba(0,0,0,.12)}
.product img{width:100%;aspect-ratio:4/3;object-fit:cover;border-radius:12px;transition:transform .25s ease,filter .25s ease}
.product:hover img{transform:scale(1.04)}
.product h4{margin:10px 0 0;font-size:.98rem;font-weight:700;color:#22313a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.product p{margin:6px 0 0;font-size:.85rem;color:#5f6b73}

/* ===== Marques (logos) ===== */
.brands-title{text-align:center;color:#05305b;font-size:36px;font-weight:800;margin:10px 0 8px;font-family:'Poppins',sans-serif;text-transform:uppercase;letter-spacing:2px}
.brands-wrapper{display:flex;align-items:center;justify-content:center;position:relative;overflow:hidden;width:100%;max-width:1200px;margin:0 auto;padding:20px 0}
.brand-container{display:flex;gap:30px;transition:transform .6s cubic-bezier(.22,.61,.36,1);will-change:transform;width:calc(5% * 5)}
.brand{
  text-align:center;flex-shrink:0;padding:10px;display:flex;align-items:center;justify-content:center;
  background:rgba(255,255,255,.6);border:1px solid rgba(0,0,0,.06);border-radius:12px;
  box-shadow:0 10px 22px rgba(0,0,0,.08);width:150px;height:150px;transition:transform .2s ease,box-shadow .25s ease,background .2s ease
}
.brand:hover{transform:scale(1.06);box-shadow:0 16px 30px rgba(0,0,0,.12)}
.brand-logo{width:100px;height:100px;object-fit:contain;filter:grayscale(18%);transition:transform .25s ease,filter .25s ease}
.brand:hover .brand-logo{transform:scale(1.12);filter:none}

/* Flèches marques (tu utilises déjà .nav-button prev/next) */
.nav-button{
  cursor:pointer;position:absolute;top:50%;transform:translateY(-50%);
  background:#fff;border:1px solid rgba(0,0,0,.08);border-radius:999px;padding:12px;width:40px;height:40px;
  display:grid;place-items:center;box-shadow:0 10px 24px rgba(0,0,0,.12);transition:transform .15s ease,background .2s ease,box-shadow .25s ease;z-index:3
}
.nav-button:hover{transform:translateY(-50%) scale(1.06);box-shadow:0 14px 32px rgba(0,0,0,.16)}
.prev-button{left:8px}
.next-button{right:8px}

/* ===== Brochure ===== */
.brochure-section{text-align:center;margin-top:30px}
.brochure-section h2{color:#05305b;font-size:30px;margin-bottom:18px;font-family:'Gill Sans','Gill Sans MT',Calibri,'Trebuchet MS',sans-serif}
@keyframes pulse{0%{transform:scale(1);box-shadow:0 0 5px rgba(224,36,11,.5)}50%{transform:scale(1.05);box-shadow:0 0 15px rgba(224,36,11,.8)}100%{transform:scale(1);box-shadow:0 0 5px rgba(224,36,11,.5)}}
.brochure-button{display:inline-block;background:#e0240b;color:#fff;padding:6px 20px;font-size:16px;font-weight:700;border-radius:8px;text-decoration:none;transition:background .25s ease,transform .2s ease;animation:pulse 2s infinite}
.brochure-button:hover{background:#c31e09;transform:translateY(-1px)}

/* ===== Icône fixe ===== */
#scrollIcon{position:fixed;bottom:20px;left:20px;display:block;cursor:pointer;transition:opacity .5s ease}
#scrollIcon img{width:30px;height:auto}

/* ===== Anim générique ===== */
@keyframes fadeIn{0%{opacity:0;transform:translateY(-20px)}100%{opacity:1;transform:translateY(0)}}

/* ===== Responsive ===== */
@media (max-width:1300px){
  .carousel{height:500px}
  .carousel-text{top:20%;font-size:16px;width:100%;border-radius:0}
  .welcome-title{font-size:20px}
  .welcome-description{font-size:12px}
  .custom-button{font-size:12px;padding:8px 18px}
  .button-description{font-size:10px}
  .welcome-heading{font-size:16px}
  .welcome-text{font-size:14px;max-width:90%;margin:0 auto}
  .product-wrapper{max-width:700px}
  .product-title{font-size:25px;margin-bottom:20px}
}
@media (max-width:1024px){
  .product-container{animation-duration:20s!important}
}
@media (max-width:450px){
  .carousel{height:400px;margin-top:0}
  .carousel-text{top:0;font-size:10px;width:100%;padding:10px;border-radius:0}
  .welcome-title{font-size:14px}
  .welcome-description{font-size:10px}
  .custom-button{font-size:10px;padding:6px 14px}
  .button-description{font-size:9px}
  .welcome-heading{font-size:10px;padding:10px}
  .welcome-image{width:100%}
  .welcome-text{font-size:10px;max-width:100%;padding:10px}
  .product-wrapper{max-width:300px;margin-bottom:50px}
  .product-title{font-size:20px;margin-bottom:20px}
}

/* ===== Anti débordement horizontal ===== */
:global(html,body){overflow-x:hidden;width:100%}
.home-container,.carousel,.welcome-section,.product-wrapper{max-width:100vw;overflow-x:hidden}

/* ===================== MODE SOMBRE AUTO ===================== */
@media (prefers-color-scheme: dark){
  .home-container{background:#0e1720;color:#e6edf1}
  .carousel{background:#0b1620}
  .video-player{filter:brightness(.92) contrast(1.05)}
  .carousel-text{background:rgba(16,24,32,.85);color:#dce8eb;border:1px solid rgba(255,255,255,.08);box-shadow:0 10px 28px rgba(0,0,0,.45)}
  .welcome-title{color:#e5ecff}
  .welcome-description{color:#bfd2d7}
  .custom-button{color:#eaf3f6;border-color:#4aa7ff22;box-shadow:0 8px 20px rgba(0,0,0,.35)}
  .custom-button:hover{background:#05305b;color:#fff;border-color:#05305b}
  .button-description{color:#a7c2ff}

  .welcome-heading{background:rgba(16,24,32,.92);color:#e7f0ff;border:1px solid rgba(255,255,255,.08);box-shadow:0 8px 22px rgba(0,0,0,.4)}
  .welcome-text{color:#cfe0e4}
  .welcome{color:#cfe2ff}
  .carousel-dot{background:rgba(255,255,255,.7);border:1px solid rgba(255,255,255,.25)}
  .carousel-dot.active{background:#00b5a6}

  .product-title{color:#cfe2ff}
  .product{background:#10161f;border:1px solid rgba(255,255,255,.06);box-shadow:0 10px 24px rgba(0,0,0,.5)}
  .product:hover{box-shadow:0 14px 28px rgba(0,0,0,.55)}
  .product img{filter:saturate(.96)}
  .product h4{color:#e7eef3}
  .product p{color:#a9bbc2}

  .features-section .feature{background:#0f1a24;border:1px solid rgba(255,255,255,.06);box-shadow:0 10px 24px rgba(0,0,0,.45)}
  .icon{color:#cfe2ff}
  h3{color:#e6edf1}
  p{color:#b7c6cc}

  .brands-title{color:#cfe2ff}
  .brand{background:rgba(16,24,32,.6);border:1px solid rgba(255,255,255,.06);box-shadow:0 10px 24px rgba(0,0,0,.45)}
  .brand-logo{filter:grayscale(10%) brightness(.98)}
  .nav-button{background:rgba(24,32,40,.92);color:#fff;border:1px solid rgba(255,255,255,.06);box-shadow:0 8px 22px rgba(0,0,0,.35)}
  .nav-button:hover{background:rgba(24,32,40,.98);box-shadow:0 12px 28px rgba(0,0,0,.45)}

  .brochure-section h2{color:#e6edf1}
  .brochure-button{background:#e0240b;color:#fff;box-shadow:0 10px 24px rgba(0,0,0,.45)}
}


/* ====== Mobile & tablette ====== */
@media (max-width: 768px){
  .features-section{
    flex-direction: column;
    gap: 16px;
    margin: 24px 12px;
  }
  .feature{
    padding: 16px 14px;
    border-radius: 10px;
    box-shadow: 0 6px 16px rgba(0,0,0,.10);
  }
  .icon{ font-size: 32px; }
  .feature h3{ font-size: 1.2rem; }
  .feature p{ font-size: .95rem; line-height: 1.5; }
}

/* ====== Téléphones ====== */
@media (max-width: 450px){
  .features-section{
    gap: 12px;
    margin: 18px 10px;
  }
  .feature{
    padding: 14px 12px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0,0,0,.10);
  }
  .icon{ font-size: 28px; }
  .feature h3{ font-size: 1.05rem; margin: 6px 0; }
  .feature hr{ width: 36px; margin: 8px auto; }
  .feature p{ font-size: .9rem; line-height: 1.45; }
  
  /* meilleurs retours tactiles */
  .feature:active{ transform: translateY(-4px); }
}


</style>

